import { memo } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import BasicBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/BasicBtn';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';

import * as S from './style';

interface IProps {
  title?: string;
  desc?: string;
  imgSrc?: string;
  rs?: string;
  onClick?: () => void;
}

const RltdCntntItem2 = ({ title, desc, imgSrc, rs, onClick }: IProps) => (
  <S.RltdCntntItem2 className="rltd-cntnt-item item">
    <Button onClick={onClick}>
      <Img src={getResizeImageUrl(imgSrc, rs)} />
      <div className="area-info">
        <Text
          weight={600}
          size={18}
          lineHeight="130%"
          ellipsis={1}
          className="title"
          block
        >
          {title}
        </Text>
        <Text
          color="#777"
          size={14}
          lineHeight="130%"
          ellipsis={2}
          className="desc"
          block
        >
          {desc}
        </Text>
      </div>
    </Button>
    <BasicBtn onClick={onClick} text="자세히 보기" />
  </S.RltdCntntItem2>
);

export default memo(RltdCntntItem2);
